// 📄 Fichier : src/testRenderUtil/useResultSender.js
import api from '@/api';
import { ref } from 'vue';
import { prepareCATResultForDatabase, validateCATData, logCATData } from '@/utils/catDataProcessor';
import { enrichResponsesWithDimensions, validateEnrichedResponses, cleanEnrichedResponsesForDatabase } from '@/utils/dimensionEnricher';

export function useResultSender(responsesStore) {
  const error = ref(null);
  const success = ref(false);

  const sendResultsToDatabase = async ({ userId, testId, publicationId, groupId, owner, catEngine = null, testData = null, conditionalData = null }) => {

console.log("📤 Envoi des résultats avec owner =", owner);

    if (!userId || !testId || !responsesStore) {
      error.value = "Informations manquantes pour l'envoi des résultats.";
      return;
    }

console.log("📤 owner reçu dans sendResultsToDatabase :", owner);

    // 📊 Enrichir les réponses avec les dimensions si testData est disponible
    let enrichedResponses = responsesStore.responses;

    if (testData) {
      try {
        console.log('📊 Enrichissement des réponses avec les dimensions...');
        enrichedResponses = enrichResponsesWithDimensions(responsesStore.responses, testData);

        // Valider l'enrichissement
        const validation = validateEnrichedResponses(enrichedResponses);
        if (validation.warnings.length > 0) {
          console.warn('⚠️ Avertissements lors de l\'enrichissement des dimensions:', validation.warnings);
        }

        // Nettoyer pour la base de données
        enrichedResponses = cleanEnrichedResponsesForDatabase(enrichedResponses);

        console.log('✅ Enrichissement des dimensions terminé:', {
          total: enrichedResponses.length,
          withDimensions: validation.statistics.withDimensions,
          uniqueDimensions: validation.statistics.uniqueDimensions?.length || 0
        });
      } catch (dimensionError) {
        console.error('❌ Erreur lors de l\'enrichissement des dimensions:', dimensionError);
        // Continuer avec les réponses non enrichies en cas d'erreur
        enrichedResponses = responsesStore.responses;
      }
    } else {
      console.warn('⚠️ TestData non disponible pour l\'enrichissement des dimensions');
    }

    // Données de base communes aux tests linéaires et CAT
    const baseResultData = {
      studentId: userId,
      testId,
      publicationId,
      groupId,
      responses: enrichedResponses,
      submittedAt: new Date().toISOString(),
      owner
    };
    
    console.log('🔍 Réponses envoyées vers la base:', responsesStore.responses.length, 'réponses');
    console.log('📋 Détail des réponses:', responsesStore.responses.map(r => ({ type: r.type, questionId: r.questionId, answered: r.answered })));

    let resultData;

    // Si c'est un test CAT, préparer les données spécifiques
    if (catEngine) {
      try {
        resultData = prepareCATResultForDatabase(baseResultData, catEngine, responsesStore);

        // Valider les données CAT
        const validation = validateCATData(resultData.catData);
        if (!validation.isValid) {
          console.error('❌ CAT Data validation failed:', validation.errors);
          error.value = 'Données CAT invalides: ' + validation.errors.join(', ');
          return;
        }

        // Logger les données CAT pour debug
        logCATData(resultData.catData, 'Envoi vers base de données');

        console.log('✅ CAT result data prepared:', {
          testType: resultData.testType,
          catDataKeys: Object.keys(resultData.catData),
          totalQuestions: resultData.catData.totalQuestionsAnswered,
          finalLevel: resultData.catData.finalLevel
        });

      } catch (catError) {
        console.error('❌ Error preparing CAT data:', catError);
        error.value = 'Erreur lors de la préparation des données CAT: ' + catError.message;
        return;
      }
    } else if (conditionalData) {
      // Test conditionnel
      resultData = {
        ...baseResultData,
        testType: 'CONDITIONAL',
        conditional: conditionalData
      };

      console.log('✅ Conditional result data prepared:', {
        testType: resultData.testType,
        pathLength: conditionalData.pathTaken?.length,
        totalResponses: conditionalData.nodeResponses?.length,
        finalScore: conditionalData.finalScore,
        terminationNodeId: conditionalData.terminationNodeId
      });
    } else {
      // Test linéaire classique
      resultData = {
        ...baseResultData,
        testType: 'LINEAR'
      };
    }

    try {
      await api.post("/results", resultData);
      success.value = true;
      console.log('✅ Results sent successfully to database');
    } catch (e) {
      error.value = 'Erreur lors de l\'envoi des résultats';
      console.error('❌ Error sending results:', e);
    }
  };

  return {
    sendResultsToDatabase,
    success,
    error,
  };
}
